// src/features/questionnaire/api/questionnaireApi.ts
import { axiosInstance } from '@/shared/api/axiosInstance';
import { RiskResult } from '../model/questionnaireSlice';

export const getActiveSurvey = async () => {
    const response = await axiosInstance.get('/surveys/active');
    return response.data;
};

export const submitSurveyAnswers = async (
    surveyId: number,
    answers: any[]
): Promise<{ instance_id: number }> => {
    const response = await axiosInstance.post('/survey/instances', {
        survey_id: surveyId,
        answers,
    });
    return response.data;
};

export const requestRiskCalculation = async (
    instanceId: number
): Promise<{ request_id: number }> => {
    const response = await axiosInstance.post(`/risks-requests?instance_id=${instanceId}`, {});
    return response.data;
};

export const getRiskStatus = async (
    requestId: number
): Promise<RiskResult> => {
    const response = await axiosInstance.get(`/risks-requests/${requestId}`);
    return response.data;
};

export const getLatestRiskResult = async (): Promise<RiskResult> => {
    const response = await axiosInstance.get('/risks-requests/latest');
    return response.data;
};
